import Routes from "./routes/Routes"

function App() {
  return (
    <div className="App fade-in">
      <Routes />
    </div>
  )
}

export default App
